module.exports = "<h3>Inactive Users</h3>\n<ul class=\"list-group\">\n  <li\n    class=\"list-group-item\"\n    *ngFor=\"let user of users; let i = index\">\n    {{ user }} | <a href=\"#\" (click)=\"onSetToActive(i)\">Set to Active</a>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/services-assigment/inactive-users/inactive-users.component.html
// module id = ./src/app/components/services-assigment/inactive-users/inactive-users.component.html
// module chunks = main